export default "__VITE_ASSET__DW08rUwP__"